<template>
    <div class="modal fade" id="registerEntityDetailsModal" role="dialog" aria-labelledby="registerEntityLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 id="registerEntityLabel">{{model.eventName}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <DetailsCard v-model="model"
                                 v-if="showDetails"
                                 @cancel="onCancel">
                    </DetailsCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { DynamicRegisterDetails } from '../../../models/models';
    import DetailsCard from './DetailsCard';

    export default {
        components: {
            DetailsCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showDetails: false,
                model: new DynamicRegisterDetails(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new DynamicRegisterDetails();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new DynamicRegisterDetails(this.value);
                    this.showDetails = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
